export const pages = [
  { index: 0, name: "highscores", route: "/highscores" },
  { index: 1, name: "spy", route: "/spy" },
  { index: 2, name: "wiki", route: "/wiki" },
  { index: 3, name: "guide", route: "/guide" , isMd: true},
  { index: 4, name: "updates", route: "/updates", isMd: true },
  { index: 5, name: "prizes", route: "/prizes" , isMd: true},
  { index: 6, name: "playershops", route: "/playershops" }
];
